<template>
  <v-row>
    <v-col class="mt-2" cols="12" offset-lg="1" lg="7">
      <v-breadcrumbs :items="breadcrumbs" divider=">" class="pl-1 pb-3" />
      <v-card>
        <v-card-title class="theme white--text">
          <v-icon class="white--text mr-2">account_box</v-icon>
          Company profile
          <v-spacer />
        </v-card-title>
        <v-card-text>
          <v-row class="pt-4">
            <v-col cols="12" lg="4" md="3" class="hidden-md-and-down">
              <v-avatar
                class="ma-3"
                size="220"
                v-if="provider.logo_url"
                rounded
                style="border: 8px solid #f8f6f4; background-color: #f8f6f4"
              >
                <v-img
                  :src="provider.logo_url"
                  :alt="provider.name"
                  style="border-radius: 7%"
                />
              </v-avatar>
              <v-avatar
                size="200"
                class="white--text my-1 grey darken-1 display-2"
                v-else
              >
                {{ provider.name ? getNameInitials(provider.name) : "" }}
              </v-avatar>
            </v-col>
            <v-col cols="12" lg="8" md="9">
              <div class="text-left pt-2 ml-5 darkertext">
                <div
                  class="headline text-capitalize"
                  v-if="provider.name"
                  v-text="provider.name"
                />
                <div
                  class="mb-8 subtitle-1"
                  style="margin-top: -0.3rem"
                  v-text="provider.description"
                />
                <div class="row mb-4">
                  <div class="col-xs-12 col-sm-2 py-0 font-weight-bold">
                    Work email
                  </div>
                  <div
                    class="col-xs-12 col-sm-10 py-0 body-2"
                    v-text="provider.contact_email"
                  />

                  <div class="col-xs-12 col-sm-2 py-0 font-weight-bold">
                    Phone
                  </div>
                  <div class="col-xs-12 col-sm-10 py-0 body-2">
                    {{ provider.contact_isd }}
                    {{ provider.contact_phone }}
                  </div>

                  <div class="col-xs-12 col-sm-2 py-0 font-weight-bold">
                    Website
                  </div>
                  <div
                    class="col-xs-12 col-sm-10 py-0 body-2"
                    v-text="provider.url"
                  />

                  <div class="col-xs-12 col-sm-2 py-0 font-weight-bold">
                    Location
                  </div>
                  <div class="col-xs-12 col-sm-10 py-0 body-2">
                    {{ provider.address_line_1 ? provider.address_line_1 : "" }}
                    {{
                      provider.address_line_2
                        ? `, ${provider.address_line_2}`
                        : ""
                    }}
                    {{ provider.city ? `, ${provider.city}` : "" }}
                    {{ provider.state ? `, ${provider.state}` : "" }}
                    {{ provider.post_code ? `, ${provider.post_code}` : "" }}
                  </div>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-title>
          Recommendations
          {{
            this.recommendation_count > 0
              ? "(" + this.recommendation_count + ")"
              : ""
          }}
          <v-spacer />
          <v-btn
            v-if="!provided_recommendation"
            class="action white--text rounded-sm"
            @click="recDialog = true"
            >Provide recommendation
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-list three-line>
            <template v-for="(item, index) in recommendations">
              <v-list-item :key="index">
                <v-list-item-avatar v-if="item.user_image" size="50">
                  <v-img :src="item.user_image" />
                </v-list-item-avatar>
                <v-list-item-avatar v-else size="50">
                  <v-avatar
                    dark
                    class="grey lighten-2 my-1 mr-5 title"
                    :style="{ color: getColorFromName(`${item.user_id}`) }"
                  >
                    {{ getNameInitials(item.user_name) }}
                  </v-avatar>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title v-text="item.user_name" />
                  <v-list-item-title
                    v-text="item.job_title + ' from ' + item.company_name"
                  />
                  <v-list-item-subtitle v-text="item.created_on" />
                  <div
                    class="body-2 text--secondary"
                    v-text="item.description"
                  />
                </v-list-item-content>
                <v-list-item-action>
                  <v-btn
                    @click="editRecommendation(item)"
                    icon
                    v-if="item.user_id == userInfo.userID"
                  >
                    <v-icon small color="yellow darken-3">edit</v-icon>
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
            </template>
          </v-list>
        </v-card-text>
      </v-card>
    </v-col>
    <v-col class="mt-15" cols="12" lg="3">
      <template v-for="(item, i) in benefits" class="mt-10">
        <div :key="i">
          <v-card class="mb-2">
            <v-img :src="item.url" height="175"></v-img>
            <v-divider />
            <v-card-title class="text-capitalize theme-text ml-4">{{
              item.name
            }}</v-card-title>
            <v-card-text class="py-0">
              <v-list dense two-line class="mt-n5" subheader>
                <!--                <v-list-item>-->
                <!--                  <v-list-item-content>-->
                <!--                    <v-list-item-title>Cost</v-list-item-title>-->
                <!--                    <v-list-item-subtitle>{{ item.cost }} {{ item.currency }} per {{ item.unit }}</v-list-item-subtitle>-->
                <!--                  </v-list-item-content>-->
                <!--                </v-list-item>-->

                <v-list-item class="mt-n4">
                  <v-list-item-content>
                    <v-list-item-title>Category</v-list-item-title>
                    <v-list-item-subtitle>{{
                      item.category
                    }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item class="mt-n4">
                  <v-list-item-content>
                    <v-list-item-title>Type</v-list-item-title>
                    <v-list-item-subtitle>{{
                      benefitType(item.type)
                    }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item class="mt-n4">
                  <v-list-item-content>
                    <v-list-item-title>Location</v-list-item-title>
                    <v-list-item-subtitle>{{
                      item.location
                    }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
              <v-btn
                text
                class="theme-text mb-3 mt-n4"
                @click="showBenefit(item.id)"
                small
                depressed
                >Read More</v-btn
              >
            </v-card-text>
          </v-card>
        </div>
      </template>
    </v-col>
    <v-dialog v-model="recDialog" persistent max-width="600">
      <v-card flat>
        <v-card-title class="headline theme white--text">
          <div>Provide a recommendation for {{ provider.name }}</div>
          <v-spacer />
          <v-btn icon @click="recDialog = !recDialog">
            <v-icon class="white--text">close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="my-3 body-2">
          <v-form ref="recommendationForm" v-model="isValid">
            <v-row>
              <v-textarea
                v-model="description"
                hint="Add recommendation for the provider"
                persistent-hint
                label="Recommendation"
                :rules="[validationRules.required, rules]"
                counter="1500"
              />
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            class="save rounded-sm white--text"
            :disabled="!isValid"
            @click="saveRecommendation"
            >Save</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="recEditDialog" persistent max-width="600">
      <v-card flat>
        <v-card-title class="headline theme white--text">
          <div>Edit recommendation for {{ provider.name }}</div>
          <v-spacer />
          <v-btn icon @click="recEditDialog = !recEditDialog">
            <v-icon class="white--text">close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="my-3 body-2">
          <v-form ref="editRecommendationForm" v-model="isValid">
            <v-row>
              <v-textarea
                v-model="description"
                hint="Add recommendation for the provider"
                persistent-hint
                label="Recommendation"
                :rules="[validationRules.required, rules]"
                counter="1500"
              />
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            class="save rounded-sm white--text"
            :disabled="!isValid"
            @click="updateRecommendation"
            >Save</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { mapGetters } from "vuex";

import { Actions } from "@/views/actions";
import { Breadcrumbs } from "@/views/breadcrumbs";
import { Component } from "@/views/component";
import { Constants } from "@/views/constants";

export default {
  name: Component.Protected.Benefit.Provider.Profile,
  computed: {
    ...mapGetters(["userInfo", "companyInfo", "me"]),
  },
  data: () => ({
    id: null,
    breadcrumbs: Breadcrumbs.Benefit.ProviderProfile,
    provider: {},
    benefits: [],
    count: 0,
    types: Constants.Benefits.Type.Select,
    recommendations: [],
    provided_recommendation: false,
    recommendation_count: 0,
    recDialog: false,
    description: "",
    recEditDialog: false,
    rec: {},
    rules: (v) => v.length <= 1500 || "Max 1500 characters",
    isValid: false,
    profileImageUrl: "",
    jobTitle: "",
  }),
  methods: {
    editRecommendation(item) {
      this.description = item.description;
      this.recEditDialog = true;
      this.rec = { ...item };
    },
    updateRecommendation() {
      if (!this.$refs.editRecommendationForm.validate()) {
        return false;
      }
      this.rec.description = this.description;
      this.$store
        .dispatch(Actions.Benefits.EditRecommendation, this.rec)
        .then((r) => {
          if (r.status === 200) {
            this.setup();
          }
        })
        .finally(() => {
          this.rec = {};
          this.recEditDialog = false;
          this.description = "";
        });
    },
    saveRecommendation() {
      if (!this.$refs.recommendationForm.validate()) {
        return false;
      }
      let payload = {
        user_id: parseInt(this.userInfo.userID),
        namespace: this.userInfo.namespace,
        job_title: this.jobTitle,
        profile_image_url: this.profileImageUrl,
        user_name: this.userInfo.username,
        provider_id: parseInt(this.provider.id),
        provider_name: this.provider.name,
        company_id: parseInt(this.companyInfo.companyId),
        company_name: this.companyInfo.name,
        description: this.description,
      };

      this.$store
        .dispatch(Actions.Benefits.AddRecommendation, payload)
        .then((r) => {
          if (r.status === 200) {
            this.setup();
          }
        })
        .finally(() => {
          this.recDialog = false;
        });
    },
    benefitType(type) {
      if (type) {
        return type.length === 1
          ? this.types.filter((e) => e.value == type[0]).map((e) => e.name)[0]
          : this.types[1].name;
      } else {
        return this.types[1].name;
      }
    },
    showBenefit(id) {
      if (!id) return false;
      this.$router.push({
        name: Component.Protected.Benefit.OnBoarding,
        params: { id: id },
      });
    },
    getMe() {
      this.$store.dispatch(Actions.Employee.Me).then(() => {
        this.jobTitle = this.me.job_title;
        this.profileImageUrl = this.me.profile_image_url;
      });
    },
    setup() {
      if (this.$route.params.id) {
        this.getMe();
        this.id = this.$route.params.id;
        this.$store
          .dispatch(Actions.Benefits.GetProviderInfoByID, this.id)
          .then((r) => {
            if (r.status === 200) {
              this.provider = r.data.provider;
              this.benefits = r.data.benefits;
              this.count = r.data.benefit_count;
              this.recommendations = r.data.recommendations;
              this.recommendation_count = r.data.recommendation_count;
              this.provided_recommendation = r.data.provided_recommendation;
            }
          });
      } else {
        this.$router.go(-1);
      }
    },
  },
  created() {
    if (this.userInfo && this.userInfo.role) {
      this.setup();
    } else {
      this.$store.dispatch(Actions.Firebase.UserInfo).then(() => this.setup());
    }
  },
};
</script>
<style scoped>
.darkertext,
a {
  color: #272929 !important;
}
</style>